const defaultConfig = {
  sectionClass: '.page-links',
  currentLinkClass: 'page-links__link--current',
  blockLinksClass: '.page-links__content .block-anchor',
  linksParentClass: '.page-links__nav',
  linksClass: '.page-links__links',
  linksActiveClass: '.page-links__links--active',
  linksFixedClass: '.page-links__links--fixed',
  linkClass: '.page-links__link'
};

export default (config, events = ['DOMContentLoaded', 'vue:loaded']) => {
  const {
    sectionClass,
    currentLinkClass,
    blockLinksClass,
    linksParentClass,
    linksClass,
    linksActiveClass,
    linksFixedClass,
    linkClass
  } = Object.assign(defaultConfig, config);

  const getModifier = () => {
    let modifier = 0;
    const nav = document.querySelector('.navbar');
    if (nav) modifier += nav.getBoundingClientRect().height;
    const hNav = document.querySelector('.horizontal-nav');
    if (hNav) modifier += hNav.getBoundingClientRect().height;
    const spacer = document.querySelector(sectionClass).previousElementSibling;
    if (spacer && spacer.matches('.appeal-spacer')) modifier += spacer.getBoundingClientRect().height;
    return modifier;
  };

  const findLastSection = (el, ...types) => {
    const sibling = el.nextElementSibling;
    if (types.filter(type => sibling.localName !== type).length === types.length) return el;
    return findLastSection(sibling, types);
  };

  const event = (e) => {
    if (!document.querySelector(sectionClass)) return;
    const currentClass = currentLinkClass;

    document.addEventListener('scroll', (e) => {
      const modifier = getModifier();
      const links = [...document.querySelectorAll(blockLinksClass)].map(
        (el, i, arr) => {
          const start = el.nextElementSibling.getBoundingClientRect().top;

          return {
            anchor: el,
            link: document
              .querySelector(`a[href="#${el.id}"]`)
              .closest(linkClass),
            top: start < modifier
          };
        }
      );

      const currentLinks = links.filter((link) => link.top);
      const currentLink = currentLinks[currentLinks.length - 1];

      links.map((link) => link.link.classList.remove(currentClass));

      if (currentLink) currentLink.link.classList.add(currentClass);
    }, {passive: true});

    const setActive = (e) => {
      const links = document.querySelector(linksClass);
      const nav = document.querySelector(linksParentClass);
      const isFixed =
        nav.getBoundingClientRect().top + nav.getBoundingClientRect().height <
        0;

      // if (links.matches(linksActiveClass)) {
      //   document.body.classList[isFixed ? 'add' : 'remove']('menu-is-open');
      // }

      nav.style.height = isFixed
        ? nav.getBoundingClientRect().height + 'px'
        : '';
      links.classList[isFixed ? 'add' : 'remove'](
        linksFixedClass.replace('.', '')
      );
    };

    document.addEventListener('scroll', setActive, {passive: true});
    document.addEventListener('DOMContentLoaded', setActive);
    document.addEventListener('vue:loaded', setActive);

    document.addEventListener('click', (e) => {
      if (!e.target.matches(linksClass)) return false;

      e.target.classList.add(linksActiveClass.replace('.', ''));
      // if (e.target.matches(linksFixedClass)) document.body.classList.add('menu-is-open');

      document.addEventListener('click', closeEvent);
    });

    const closeEvent = (e) => {
      if (!e.target.matches(`${linksActiveClass} a`) && e.target.closest(linksActiveClass) && !e.target.matches(linksClass)) return false;
      // console.log(e.target, e.target.closest(`.${currentLinkClass}`), window.scrollY);
      // if (e.target.closest(`.${currentLinkClass}`)) window.scrollTo(0, window.scrollY);

      document.querySelector(linksClass).classList.remove(linksActiveClass.replace('.', ''));
      // document.body.classList.remove('menu-is-open');
      document.removeEventListener('click', closeEvent);
    };
  };

  document.addEventListener('click', e => {
    if (!e.target.matches(`${sectionClass} ${linkClass}`) && !e.target.closest(linkClass)) return;
    e.preventDefault();
    const id = decodeURI(e.target.closest('a').href.replace(window.location.origin + window.location.pathname, '').replace('#', ''));
    
    // console.log(document
    //   .querySelector(id), document
    //   .querySelector(id)
    //   .closest(linkClass));

    const block = [...document.querySelectorAll('.block-anchor')].filter(link => link.id === id)[0];
    
    window.scrollBy(0, block.getBoundingClientRect().top - getModifier());

    document.querySelector('.navbar').classList[block.getBoundingClientRect().top - getModifier() > 0 ? 'add' : 'remove']('navbar--hidden');
    return window.scrollBy(0, block.getBoundingClientRect().top - getModifier());
  });

  events.map(trigger => document.addEventListener(trigger, event));
};
